import React from "react";
import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SiteLayout from "../site/SiteLayout";
import { lazyPage } from "../lib/lazyPage";
const IntroPage = lazyPage(() => import("./pages/IntroPage"));
const WizardPage = lazyPage(() => import("./pages/WizardPage"));
const SavedResultsPage = lazyPage(() => import("./pages/SavedResultsPage"));
const ClientPage = lazyPage(() => import("./pages/ClientPage"));
const TermsPage = lazyPage(() => import("./pages/TermsPage"));
const PrivacyPage = lazyPage(() => import("./pages/PrivacyPage"));
import "./rc.css";

const B = "/renewal-checker";

function Wrap({ children }) {
  return (<><Helmet><link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Outfit:wght@300;400;500;600;700&display=swap" rel="stylesheet" /><link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&display=swap" rel="stylesheet" /></Helmet><SiteLayout outside={<div className="rc rc-v2" data-testid="rc-root">{children}</div>} /></>);
}

// Spread inside <Routes>: {rcRoutes()}
export function rcRoutes() {
  const pages = [["/", IntroPage], ["/checker", WizardPage], ["/results/:token", SavedResultsPage], ["/client/:token", ClientPage], ["/terms", TermsPage], ["/privacy", PrivacyPage]];
  return pages.flatMap(([p, C]) => [B + p, B + p + "/"].filter((x, i, a) => a.indexOf(x) === i).map((path) => <Route key={path} path={path} element={<Wrap><C /></Wrap>} />));
}
